import { Action, ActionReducer, INIT } from '@ngrx/store';

import { State } from '@app/store/state/state';
import { DefaultNavigationState } from '@app/store/reducers/globalUi/navigation.reducer';
import { HeaderPageType } from '@header/entities/ds-header-config';
import { NavigationItem } from '@app/entities/router-state.entity';

const NavigationStorageKey = 'navigation_storage';

const restoreNavigation = (pageType: HeaderPageType) => {
  return pageType === HeaderPageType.BookingPage;
};

const getNavigationState = (nav: NavigationItem, storage: string) => {
  return restoreNavigation(nav?.PageType) ? JSON.parse(storage) : DefaultNavigationState;
};

const getHydratedState = (state: State, action: Action, reducer: ActionReducer<State>) => {
  const _state = reducer(state, action);
  const _navigation = _state?.globalUi?.navigation ?? DefaultNavigationState;
  const _default = {
    ..._state,
    globalUi: {
      ..._state.globalUi,
      navigation: _navigation
    }
  };
  try {
    if (action.type === INIT) {
      const _navStorage = sessionStorage.getItem(NavigationStorageKey);
      if (_navStorage?.length) {
        const _obj = JSON.parse(_navStorage);
        const _lastNav: NavigationItem = _obj?.[_obj?.length - 1];
        try {
          return {
            ..._state,
            globalUi: {
              ..._state.globalUi,
              navigation: getNavigationState(_lastNav, _navStorage)
            }
          };
        } catch {
          sessionStorage.removeItem(NavigationStorageKey);
        }
      }
    }
    sessionStorage.setItem(NavigationStorageKey, JSON.stringify(_navigation));
    return _default;
  } catch (e) {
    return _default;
  }
}

export const hydrationMetaReducer = (reducer: ActionReducer<State>): ActionReducer<State> => {
  return (state, action) => getHydratedState(state, action, reducer);
};

export const exportedForTesting = { getHydratedState, getNavigationState }
